export default class ColorConstants {
    public static GraphColors: any[] = [
        {
            // DarkRed
            backgroundColor: 'rgba(200, 1, 1, 0.15)',
            borderColor: 'rgba(200, 1, 1,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        },
        {
            // Blue
            backgroundColor: 'rgba(1, 55, 150, 0.15)',
            borderColor: 'rgba(1, 55, 150,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        {
            // Orange
            backgroundColor: 'rgba(255, 100, 20, 0.15)',
            borderColor: 'rgba(255, 100, 20,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        {
            // Green
            backgroundColor: 'rgba(0, 145, 2, 0.15)',
            borderColor: 'rgba(0, 145, 2,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        {
            // Purple
            backgroundColor: 'rgba(116, 0, 145, 0.15)',
            borderColor: 'rgba(116, 0, 145,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        {
            // Brown
            backgroundColor: 'rgba(112, 38, 2, 0.15)',
            borderColor: 'rgba(112, 38, 2,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
        },
        {
            // Transparent
            backgroundColor: 'rgba(0, 0, 0, 0.0)',
            borderColor: 'rgba(0, 0, 0, 0.0)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)'
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/constants/color-constants.ts